/* eslint-disable */
const WAREHOUSE = {
  WAREHOUSE_REPORT_REMAIN: 'warehouse/report/remain',
  WAREHOUSE_REPORT_CARDEX: 'warehouse/report/cardex',
  WAREHOUSE_REPORT_FLOW: 'warehouse/report/flow',
  WAREHOUSE_TYPE_LIST_PRIMARYWAREHOUSE: 'warehouse/type/list/primaryWarehouse',
  WAREHOUSE_TYPE_ADD_WAREHOUSE: 'warehouse/type/add/warehouse',
  WAREHOUSE_TYPE_LIST_WAREHOUSE: 'warehouse/type/list/warehouse',
  WAREHOUSE_REPORT_INCOMPLATIBLE_DELIVERYREMAIN: 'warehouse/report/incompatible/deliveryRemain',
  WAREHOUSE_REPORT_INCOMPLATIBLE_CARDEXREMAIN: 'warehouse/report/incompatible/cardexRemain',
  WAREHOUSE_TYPE_ADD_DOCUMENT: 'warehouse/type/add/document',
  WAREHOUSE_TYPE_DELETE_DOCUMENT: 'warehouse/type/delete/document',
  WAREHOUSE_TYPE_EDIT_DOCUMENT: 'warehouse/type/edit/document',
  WAREHOUSE_REPORT_TYPE_DOCUMENT: 'warehouse/report/type/document',
  WAREHOUSE_REPORT_TYPE_WAREHOUSE: 'warehouse/report/type/warehouse',
  WAREHOUSE_TYPE_DISABLE_DOCUMENT: 'warehouse/type/disable/document',
  WAREHOUSE_TYPE_ENABLE_DOCUMENT: 'warehouse/type/enable/document',
  WAREHOUSE_REPORT_PREVIEW: 'warehouse/report/preview',
  WAREHOUSE_DOCUMENT_GET_PREVIEW: 'warehouse/document/get/preview',
  WAREHOUSE_TYPE_LIST_DOCUMENT: 'warehouse/type/list/document',
  WAREHOUSE_DOCUEMNT_EDIT_PREVIEW: 'warehouse/document/edit/preview',
  WAREHOUSE_DOCUEMNT_DELETE_PREVIEW: 'warehouse/document/delete/preview',
  WAREHOUSE_REPORT_DOCUMENT: 'warehouse/report/document',
  WAREHOUSE_OPERATOR_TYPELIST: 'warehouse/operator/typeList',
  WAREHOUSE_SHIPPING_PRODUCT_PRICE: 'retail/shipping/product/price',
  WAREHOUSE_DOCUEMNT_RECORD_DOCUMENT: 'warehouse/document/record/document',
  WAREHOUSE_DOCUEMNT_GET_DOCUMENT: 'warehouse/document/get/document',
  WAREHOUSE_DOCUEMNT_RECORD_PREVIEW: 'warehouse/document/record/preview',
  WAREHOUSE_TYPE_DELETE_WAREHOUSE: 'warehouse/type/delete/warehouse',
  WAREHOUSE_TYPE_EDIT_WAREHOUSE: 'warehouse/type/edit/warehouse',
  WAREHOUSE_TYPE_DISALBE_WAREHOUSE: 'warehouse/type/disable/warehouse',
  WAREHOUSE_TYPE_ENABLE_WAREHOUSE: 'warehouse/type/enable/warehouse'
}
export default WAREHOUSE
